import React, { useEffect } from "react"

export function PlaceOrder() {
  return <p>下单面板</p>
}
